export default __webpack_public_path__ + "static/media/march2023-3.554bba30.jpg";